
<template>
  <div class="container">
    <div class="loading" v-if="loading">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">General</h1>
          <p class="view-header__subtitle">Configuraciones generales del sistema.</p>
        </div>
      </div>
    </div>

    <div class="row d-flex justify-content-center">

      <div class="col-md-4 mt-4">
        <div class="form-card">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-currency-dollar"></i>
              Configuraciones de Moneda
            </h6>
          </div>

          <div class="form-card__body">
            <div class="form-card__field">
              <label class="form-card__label" for="currency-decimal-separator">Separador de miles</label>
              <input
                id="currency-decimal-separator"
                v-model.trim="configurations.CURRENCY_DECIMAL_SEPARATOR"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': state === false }"
                placeholder="Ej: ,"
              >
              <div v-if="state === false" class="form-card__error">El valor debe tener un mínimo de 1 letra</div>
              <div v-else class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="currency-thousand-separator">Separador de decimales</label>
              <input
                id="currency-thousand-separator"
                v-model.trim="configurations.CURRENCY_THOUSAND_SEPARATOR"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': state === false }"
                placeholder="Ej: ."
              >
              <div v-if="state === false" class="form-card__error">El valor debe tener un mínimo de 1 letra</div>
              <div v-else class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="currency-decimal-digits">Cantidad de dígitos decimales</label>
              <input
                id="currency-decimal-digits"
                v-model.trim="configurations.CURRENCY_DECIMAL_DIGITS"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': state === false }"
                placeholder="Ej: 2"
              >
              <div v-if="state === false" class="form-card__error">El valor debe tener un mínimo de 1 letra</div>
              <div v-else class="form-card__hint">Campo obligatorio</div>
            </div>
          </div>

          <div class="form-card__footer">
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="state === false || loading"
              @click="save()"
            >
              <i class="bi bi-check-lg"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-4 mt-4">
        <div class="form-card">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-file-earmark-lock"></i>
              Archivos de certificados de Afip
            </h6>
          </div>

          <div class="form-card__body">
            <div class="form-card__field">
              <label class="form-card__label" for="cuit">CUIT</label>
              <select
                id="cuit"
                v-model="afipCertificates.CUIT"
                class="custom-select"
                required
              >
                <option value="" disabled>Seleccione el CUIT</option>
                <option v-for="cuit in cuitList" :key="cuit" :value="cuit">{{ cuit }}</option>
              </select>
              <div class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="crtFile">Certificado</label>
              <input
                id="crtFile"
                type="file"
                class="form-control"
                @change="handlecrtFile"
              >
              <div class="form-card__hint">Campo obligatorio - formato .crt</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="keyFile">Clave</label>
              <input
                id="keyFile"
                type="file"
                class="form-control"
                @change="handleKeyFile"
              >
              <div class="form-card__hint">Campo obligatorio - formato .key</div>
            </div>
          </div>

          <div class="form-card__footer">
            <div v-if="!afipCertificateState" class="form-card__error" style="margin-right: auto;">
              Error en los campos, por favor verificar
            </div>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!afipCertificateState"
              @click="sendCertificateFiles()"
            >
              <i class="bi bi-upload"></i>
              Enviar
            </button>
          </div>
        </div>
      </div>
      <!--
      <div class="col-md-4 mt-4">
        <CargaMasivaProductos />
      </div>
      -->
    </div>
  </div>
</template>

<script>
import CargaMasivaProductos from '../sub-components/Carga-masiva-productos.vue';


export default {
  components: {
    CargaMasivaProductos,
  },
  data: function() {
    return {
      configurations:{
        CURRENCY_DECIMAL_SEPARATOR:'',
        CURRENCY_DECIMAL_DIGITS:'',
        CURRENCY_THOUSAND_SEPARATOR:''
      },
      afipCertificates:{
        crtFile: null,
        keyFile: null,
        CUIT: '',
      },
       cuitList: [],
      loading: false,
    };
  },
  mounted() {
    this.getConfigurations();
    this.getCuits();
  },
  computed: {
    state() {
      return this.configurations.CURRENCY_DECIMAL_SEPARATOR.length < 1 ||
         this.configurations.CURRENCY_DECIMAL_DIGITS.length < 1 ||
          this.configurations.CURRENCY_THOUSAND_SEPARATOR.length < 1
        ? false
        : null;
    },

    afipCertificateState() {
      return this.afipCertificates.crtFile == null ||
         this.afipCertificates.keyFile == null ||
          this.afipCertificates.CUIT.length != 11
        ? false
        : true;
    },

  },
  watch: {
  
  },
  methods: {    
    handlecrtFile(event) {
    this.afipCertificates.crtFile = event.target.files[0];
    },
    handleKeyFile(event) {
      this.afipCertificates.keyFile = event.target.files[0];
    },
    async sendCertificateFiles() {
      this.loading = true;
      try {
  
        // Enviar archivos
        const formData = new FormData();
        formData.append("crt_file", this.afipCertificates.crtFile);
        formData.append("key_file", this.afipCertificates.keyFile);
        formData.append("cuit", this.afipCertificates.CUIT);

        await this.$http.post("/api/configs/upload-afip-certificates", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

      } catch (e) {
        console.error(e);
        alert("Error al subir los archivos");
      }
      this.loading = false;
       alert("Archivos subidos correctamente");
    },

    getConfigurations() {
      var vm = this;
      vm.loading = true
      this.$http.get("/api/configs/getConfigurations").then((response) => {
        vm.configurations = response.data.data;
        vm.loading = false
      });
    },
    getCuits() {
      var vm = this;
      this.$http.get("/api/configs/branchoffice/getCuitList").then((response) => {
        vm.cuitList = response.data.data;
      });
    },

    save() {
      if (this.loading) return;
      this.loading = true
        this.$http
          .post("/api/configs/updateConfigurations",this.configurations)
          .then((response) => {

            console.log(response.data);
            this.getConfigurations();
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>

<style>
  .divActions {
    float: right;
  }
  .marginButton {
    margin-left: 10px;
  }
</style>
